import React from "react";
import {
    CompassOutlined,
    EditOutlined,
    EnvironmentOutlined,
    GlobalOutlined,
    RadiusSettingOutlined,
} from "@ant-design/icons";
import { Localize } from "components/service";


const fieldStyles = new Map([
    [ "latitude", { Icon: CompassOutlined, category: "coordinates" } ],
    [ "longitude", { Icon: CompassOutlined, category: "coordinates" } ],
    [ "radius", { Icon: RadiusSettingOutlined, category: "radius" } ],
    [ "country", { Icon: GlobalOutlined, category: "country" } ],
    [ "address", { Icon: EnvironmentOutlined, category: "address" } ],
]);
const unknownFieldStyle = { Icon: EditOutlined, category: "unknown" };

const StaffCheckInHistoryChangedFieldsField = ({ fields = [] }) => (
    <span className="staff-check-in-history__changed-fields">
        { fields.map(({ name, labelKey }, index) => {
            const normalizedName = name.toLowerCase().replace(/^check_/, "");
            const { Icon, category } = fieldStyles.get(normalizedName) || unknownFieldStyle;

            return (
                <span
                    className={ `staff-check-in-history__changed-field staff-check-in-history__changed-field--${ category }` }
                    key={ `${ name }_${ index }` }>
                    <span className="staff-check-in-history__changed-field-icon" aria-hidden="true">
                        <Icon />
                    </span>
                    <span className="staff-check-in-history__changed-field-label">
                        { labelKey ? <Localize>{ labelKey }</Localize> : name }
                    </span>
                </span>
            );
        }) }
    </span>
);

export default StaffCheckInHistoryChangedFieldsField;
